import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  CommonHeader,
  ConfirmationModal,
  ErrorSuccessModal,
  Loader,
} from "../../../components/commons";
import {
  DropDownType,
  GetClientDirectoryListPayloadType,
} from "../../../commonTypes/clientDirectoryTypes";
import RecurringJobsTable from "../../../components/Jobs/RecurringJobsSetting";
import { getClientDirectoryListAction } from "../../../redux/clientDirectory";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import Select from "react-select";
import useDebounce from "../../../customHooks/useDebounce";
import {
  addRecurringJobsDetailsAction,
  getRecurringJobsDetailsAction,
  resetError,
  resetFetching,
  resetRecurringJobsDetailsList,
  resetStatusCode,
  resetSuccess,
} from "../../../redux/jobs";
import { resetSession } from "../../../redux/auth";
import {
  AddRecurringJobTypePayload,
  GetRecurringJobsSettingPayload,
} from "../../../commonTypes/jobsType";

type AppProps = {
  history: any;
  token: string | null;
  error: string | null | undefined;
  success: number | null;
  statusCode: number | null;
  fetching: boolean;
  clientFetching: boolean;
  totalCount: number | null;
  clientDirectoryList: [] | ClientDirectoryListType[];
  singleRecurringJobsDetails: any;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  dispatchAddRecurringJobsDetailsAction: (
    data: AddRecurringJobTypePayload
  ) => void;
  dispatchGetRecurringJobsDetailsAction: (
    data: GetRecurringJobsSettingPayload
  ) => void;
  dispatchResetSession: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetError: () => void;
  dispatchResetFetching: () => void;
  dispatchResetRecurringJobsDetailsList: () => void;
};
const EditRecurringJobSetting = ({
  history,
  token,
  statusCode,
  success,
  fetching,
  error,
  totalCount,
  clientFetching,
  clientDirectoryList,
  singleRecurringJobsDetails,
  dispatchGetClientDirectoryListAction,
  dispatchAddRecurringJobsDetailsAction,
  dispatchResetSession,
  dispatchResetSuccess,
  dispatchResetStatusCode,
  dispatchResetError,
  dispatchGetRecurringJobsDetailsAction,
  dispatchResetRecurringJobsDetailsList,
  dispatchResetFetching,
}: AppProps) => {
  const redirectClientName = history?.location?.state?.companyName;
  const redirectClientCode = history?.location?.state?.clientCode;
  const [finalClientList, setFinalClientList] = useState<any>([]);
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setoffset] = useState<number>(0);
  const [clientName, setClientName] = useState<DropDownType>({
    value: null,
    label: "Select..",
  });
  const [clientCodeError, setClientCodeError] = useState("");
  const [formError, setFormError] = useState(false);
  const [updatedData, setUpdatedData] = useState<any[]>([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [recurringUpdate, setRecurringUpdate] = useState(false);

  const jobType = history?.location?.state?.jobType;
  const sortByCc = history?.location?.state?.sortByCc;
  const searchTerm = history?.location?.state?.searchTerm;

  const redirectedRecurringReportClientCode =
    localStorage.getItem("client_code");
  const redirectRecurringReportClientName = localStorage.getItem("client_name");
  const [localClientCode , setLocalClientCode] = useState<any>("")
  const [localClientName , setLocalClientName] = useState<any>("")

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetSuccess();
    dispatchResetError();
    dispatchResetFetching();
    dispatchResetRecurringJobsDetailsList();
  }, []);
  useEffect(() => {
    if (clientName?.value && token) {
      const finalData = {
        token,
        clientCode: clientName?.value,
      };
      dispatchGetRecurringJobsDetailsAction(finalData);
    }
  }, [clientName?.value]);

  useEffect(() => {
    const finalClientListData = clientDirectoryList?.map((data: any) => {
      return {
        value: data?.client_code,
        label: `(${data?.client_code}) ${data?.company_name}`,
      };
    });
    if (offset > 0) {
      setFinalClientList([...finalClientList, ...finalClientListData]);
    } else {
      setFinalClientList(finalClientListData);
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    if (token && totalCount) {
      if (offset <= +totalCount) {
        const finalData = {
          token,
          status: 1,
          offset,
          limit,
          searchValue: text,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [offset]);

  const fetchNewData = () => {
    const finalData = {
      token,
      status: 1,
      offset,
      limit,
      searchValue: text,
    };
    dispatchGetClientDirectoryListAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData();
      } else {
        const finalData = {
          token,
          status: 1,
          offset,
          limit,
          searchValue: text,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    },
    500,
    [text]
  );

  useEffect(() => {
    if (redirectClientName && redirectClientCode) {
      setClientName({
        value: redirectClientCode,
        label: redirectClientName,
      });
    }
  }, [redirectClientName, redirectClientCode]);

useEffect(()=>{
  setLocalClientCode(redirectedRecurringReportClientCode)
  setLocalClientName(redirectRecurringReportClientName)
},[redirectedRecurringReportClientCode,redirectRecurringReportClientName])


  
  // calling while redirect
  useEffect(() => {
    if (
      localClientCode &&
      localClientName
    ) {
      if (token) {
        if (
          localClientCode &&
          localClientName
        ) {
          setClientName({
            value: localClientCode,
            label: localClientName,
          });
        } else {
          setClientName({
            value: null,
            label: "Select..",
          });
        }

        const finalData = {
          token,
          clientCode: localClientCode,
        };
        setRecurringUpdate(true);
        dispatchGetRecurringJobsDetailsAction(finalData);
        handleResetData();
      }
    }
  }, [localClientCode, localClientName]);

  const handleClientChanges = (data: any) => {
    setClientName({
      value: data?.value,
      label: data?.label,
    });
    setClientCodeError("");
  };

  const checkBottom = (e: any) => {
    setoffset((prv: any) => prv + limit);
  };

  const handleResetData = () => {

      localStorage.removeItem("client_code");
      localStorage.removeItem("client_name");
  
  };

  const handleSubmit = (data: any) => {
    window.scroll({
      top: 0,
      left: 0,
    });
    let flag = true;
    let confirmationModal = false;
    let jobDetailsArrayChange = false;
    let count = 0;
    data?.map((el: any) => {
      if (
        el?.jobType?.value === null ||
        el?.manager?.value === null ||
        el?.responsible?.value === null
      ) {
        return (flag = false);
      }
    });
    data?.map((el: any) => {
      if (el?.dateChanged && el?.reqId) {
        return (confirmationModal = true);
      }
      if (el?.reqId) {
        count++;
      }
    });
    if (token && clientName?.value && flag) {
      const finalData = {
        token,
        clientCode: +clientName?.value,
        jobDetails: data,
      };
      if (
        confirmationModal ||
        count !== singleRecurringJobsDetails?.job_details?.length
      ) {
        setUpdatedData(data?.length ? [...data] : []);
        setShowConfirmationModal(true);
      } else {
        dispatchAddRecurringJobsDetailsAction(finalData);
      }
    } else {
      setFormError(true);
      {
        !clientName?.value && setClientCodeError("Please Select Client!");
      }
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Client Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            history.push({
              pathname: `/jobs/recurring-jobs`,
              state: {
                companyName: redirectClientName,
                clientCode: redirectClientCode,
                jobType,
                sortByCc,
                searchTerm,
              },
            });
            dispatchResetSuccess();
            dispatchResetError();
            dispatchResetStatusCode();
            dispatchResetRecurringJobsDetailsList();
            setClientName({
              value: null,
              label: "Select..",
            });
          }}
          statusCode={statusCode}
        />
      );
    }
  };

  const afterConfirmation = () => {
    if (clientName?.value) {
      const finalData = {
        token,
        clientCode: +clientName?.value,
        jobDetails: updatedData,
      };
      dispatchAddRecurringJobsDetailsAction(finalData);
    }
  };

  return (
    <>
      <div className="row">
        <CommonHeader title="Recurring Job Setting" />
      </div>
      <div
        style={{
          backgroundColor: "white",
          paddingTop: "23px",
          border: "1px solid #bfcbe1",
          borderRadius: "6px",
        }}
      >
        <div className="row  ml-2">
          <div className="col-md-4">
            <h5 style={{ fontSize: "20px", color: "#262a44" }}>
              Update Recurring Job Setting
            </h5>
            <p style={{ color: "#7c8db0", fontSize: "13px" }}>
              Please update recurring job setting for selected client
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 ml-4">
            <label htmlFor="Select Client" className="mb-2">
              Select Client<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              options={finalClientList}
              className={`${clientCodeError ? "error-border rounded" : ""}`}
              value={clientName}
              onChange={handleClientChanges}
              isSearchable={true}
              isLoading={clientFetching}
              onMenuClose={() => {
                setoffset(0);
              }}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              onInputChange={(e) => {
                setText(e);
              }}
              // isDisabled={redirectClientName && redirectClientCode && localClientCode &&localClientName}
              isDisabled={clientName?.value !== null && clientName?.label !== "Select.."} 
            />
            {clientCodeError && (
              <small className="text-danger">
                {clientCodeError ? clientCodeError : ""}
              </small>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <RecurringJobsTable
              history={history}
              clientName={clientName}
              success={success}
              formError={formError}
              handleSubmit={handleSubmit}
              jobDetails={singleRecurringJobsDetails?.job_details}
            />
          </div>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            setShowConfirmationModal(!showConfirmationModal);
          }}
          isOpen={showConfirmationModal}
          message={`You're changing the details of Recurring Job Setting. All of the scheduling will be deleted. Are you sure you want to continue?`}
          confirmButtonText={"Continue"}
          onPressConfirm={() => {
            setShowConfirmationModal(!showConfirmationModal);
            afterConfirmation();
          }}
        />
      )}
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  token: state.auth.token,
  totalCount: state.clientDirectory.totalCount,
  clientFetching: state.clientDirectory.fetching,
  success: state.jobs.success,
  statusCode: state.jobs.statusCode,
  error: state.jobs.error,
  fetching: state.jobs.fetching,
  singleRecurringJobsDetails: state.jobs.singleRecurringJobsDetails,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchAddRecurringJobsDetailsAction: (data: AddRecurringJobTypePayload) =>
    dispatch(addRecurringJobsDetailsAction(data)),
  dispatchGetRecurringJobsDetailsAction: (
    data: GetRecurringJobsSettingPayload
  ) => dispatch(getRecurringJobsDetailsAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetStatusCode: () => dispatch(resetStatusCode()),
  dispatchResetFetching: () => dispatch(resetFetching()),
  dispatchResetRecurringJobsDetailsList: () =>
    dispatch(resetRecurringJobsDetailsList()),
  dispatchResetError: () => dispatch(resetError()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditRecurringJobSetting);
